export interface LegendContentOptions {
  isTopView: boolean;
  phone: string;
  email: string;
}

/**
 * HTML of the "Location Legend" modal. Color classes are written out in full (never
 * `bg-${value}`): the stylesheet only generates classes it finds as literal strings in the source.
 * `bg-dvm-isolated` follows the club's own dvm `seat-available-pending` color.
 */
export function buildLegendContent({
  isTopView,
  phone,
  email,
}: LegendContentOptions): string {
  const dynamicLegend = isTopView
    ? { text: 'Selected', colorClass: 'bg-purple' }
    : { text: 'Isolated', colorClass: 'bg-dvm-isolated' };

  return `<span id="legend">
                  <span class="mb-2 flex justify-center">
                    <span class="mx-2 flex items-center">
                      <span class="w-2 h-2 mx-2 bg-dvm-available rounded-full"></span>
                      <p>Available</p>
                    </span>
                    <span class="mx-2 flex items-center">
                      <span class="w-2 h-2 mx-2 bg-red rounded-full"></span>
                      <p>My seats</p>
                    </span>
                    <span class="mx-2 flex items-center">
                      <span class="w-2 h-2 mx-2 ${dynamicLegend.colorClass} rounded-full"></span>
                      <p>${dynamicLegend.text}</p>
                    </span>
                  </span>
                </span>
                <span class="lg:hidden mt-4 block border-gray-200 border-t pt-4 text-center">
                  <p class="m-0">For questions or assistance:</p>
                  <p class="m-0">
                    Please call <b class="font-extrabold">${phone}</b>
                    or email <b class="font-extrabold">${email}</b>
                  </p>
                </span>`;
}
